import React, { useState } from 'react';
import { BoxV2 as Box, Flex, ButtonV2 as Button } from 'portal-commons';
import { Checkbox } from '@/components';
import { Brand } from '@/apis/core';
import RegistrationBrandDetailsForm from '../BrandRegistrationV2/BrandDetailsForm';
import { BrandDetailsFormValues } from '../BrandRegistrationV2/types';

interface BrandDetailsFormProps {
  brand?: Brand;
  onCancel?: () => void;
  onSubmit?: (data: BrandDetailsFormValues, isResubmit: boolean) => void;
  proceeding?: boolean;
}

const BrandDetailsForm: React.FC<BrandDetailsFormProps> = ({
  brand,
  onCancel,
  onSubmit,
  proceeding = false,
}) => {
  const [feeAccepted, setFeeAccepted] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [hasErrors, setHasErrors] = useState(false);
  const [isValidating, setIsValidating] = useState(false);

  return (
    <Flex sx={{ flexDirection: 'column', gap: 'xl', width: '100%', px: 'xs' }}>
      <Flex
        sx={{
          flexDirection: 'column',
          gap: '16px',
          alignItems: 'flex-start',
          color: 't.black90',
          maxWidth: '614px',
          lineHeight: 'normal',
        }}
      >
        <Box sx={{ fontSize: '24px' }}>Edit Brand</Box>
        <Box sx={{ fontSize: '16px' }}>
          Editing your Company Registration Number / ID, Issuing Country, Brand
          Legal Name, Brand DBA Name, or Entity Type will reset your status to
          UNVERIFIED. You must resubmit the brand for verification to create new
          campaigns.
        </Box>
      </Flex>
      <Box sx={{ height: '1px', width: '100%', bg: '#cccfd0' }} />

      <RegistrationBrandDetailsForm
        formId="editBrandForm"
        defaultValues={brand as unknown as BrandDetailsFormValues}
        hideActions={true}
        showTitle={false}
        onSubmit={(data) => onSubmit?.(data, isDirty)}
        onIdentifyingFieldsChange={setIsDirty}
        onErrorsChange={setHasErrors}
        onValidatingChange={setIsValidating}
        validationMode="onTouched"
      />
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          gap: 'xl',
          mb: 's',
        }}
      >
        <Box sx={{ flex: '1' }}>
          <Checkbox
            checked={isDirty ? feeAccepted : false}
            onChange={setFeeAccepted}
            disabled={!isDirty}
            label="I understand that these changes require my brand to be reverified."
            data-testid="editBrandFeeCheckbox"
          />
        </Box>
        <Flex sx={{ gap: 'xl' }}>
          <Button
            shape="square"
            variant="outline"
            size="lg"
            color="secondary"
            disabled={proceeding}
            onClick={onCancel}
            data-testid="editBrandCancelBtn"
          >
            Cancel
          </Button>
          <Button
            shape="square"
            type="submit"
            form="editBrandForm"
            size="lg"
            color="secondary"
            disabled={
              proceeding ||
              isValidating ||
              hasErrors ||
              (isDirty && !feeAccepted)
            }
            data-testid="editBrandSaveBtn"
          >
            {proceeding ? 'Processing' : isDirty ? 'Save & Resubmit' : 'Save'}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default BrandDetailsForm;
